import styled from 'styled-components';

export const GeneralChatStyled = styled.div`
    .icon-container {
        position: fixed;
        bottom: 100px;
        right: 15px;
        height: 80px;
        width: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgba(255,255,255,.5);
        border-radius: 100%;
        cursor: pointer;
        z-index: 500;
        transition: .3s;

        .icon-image {
            width: 70px;
            object-fit: contain;
            transition: .3s;
        }

        &:hover {
            .icon-image {
                width: 80px;
            }
        }

        

        .icon {
            color: white;
        }

        .icon-text {
            color: white;
        }
    }

    .chat-modal {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: 9999 !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        color: inherit;
        
        isolation: isolate;

        .backdrop {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            background-color: rgba(0,0,0,.5) !important;
            z-index: 9998 !important;
        }

        .chat-container {
            position: relative;
            width: 100%;
            max-width: 500px;
            height: 90%;
            max-height: 600px;
            background-color: white;
            border: 1px solid var(--greenia-color);
            border-radius: 10px;
            z-index: 10000;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            overflow-x: hidden;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
            
            font-family: inherit;
            font-size: inherit;
            line-height: inherit;
            color: inherit;
            
            * {
                box-sizing: border-box;
            }
            
            .d-flex {
                display: flex !important;
            }
            
            .justify-content-between {
                justify-content: space-between !important;
            }
            
            .align-items-center {
                align-items: center !important;
            }
            
            .gap-2 {
                gap: 0.5rem !important;
            }
            
            .fw-bold {
                font-weight: bold !important;
            }

            .chat-background-image {
                position: absolute;
                top: 50px;
                height: calc(100% - 100px);
                transform: translate(-50%, 0);
                opacity: .6;
            }

            .chat-title {
                padding: 10px;
                color: white;
                font-size: 16px;
                text-align: center;
                font-weight: bold;
                background-color: var(--greenia-color);
                border-bottom: 1px solid white;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                display: flex !important;
                justify-content: space-between !important;
                align-items: center !important;
                min-height: 50px;
                flex-wrap: nowrap !important;
                position: relative;
                z-index: 10001;

                &.d-flex {
                    display: flex !important;
                }

                .chat-title-info {
                    flex: 1 1 auto !important;
                    text-align: left !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    white-space: nowrap !important;
                    margin-right: 10px !important;
                    font-size: 14px !important;
                    line-height: 1.2 !important;
                    display: block !important;
                    max-width: calc(100% - 80px) !important;
                    
                    &.fw-bold {
                        font-weight: bold !important;
                        display: block !important;
                    }
                }

                .chat-title-actions {
                    display: flex !important;
                    align-items: center !important;
                    gap: 8px !important;
                    flex-shrink: 0 !important;
                    flex: 0 0 auto !important;
                    min-width: 70px !important;
                    
                    &.d-flex {
                        display: flex !important;
                    }
                    
                    &.align-items-center {
                        align-items: center !important;
                    }
                    
                    &.gap-2 {
                        gap: 0.5rem !important;
                    }
                    
                    button {
                        background: none !important;
                        border: none !important;
                        color: white !important;
                        padding: 5px !important;
                        border-radius: 3px !important;
                        transition: background-color 0.2s !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        min-width: 30px !important;
                        min-height: 30px !important;
                        box-shadow: none !important;
                        opacity: 1 !important;
                        visibility: visible !important;
                        flex-shrink: 0 !important;
                        
                        &.btn {
                            display: flex !important;
                            visibility: visible !important;
                            opacity: 1 !important;
                        }
                        
                        &.btn-sm {
                            min-width: 30px !important;
                            min-height: 30px !important;
                            padding: 5px !important;
                        }
                        
                        &:hover {
                            background-color: rgba(255, 255, 255, 0.1) !important;
                            color: white !important;
                        }
                        
                        &:focus {
                            outline: none !important;
                            background-color: rgba(255, 255, 255, 0.2) !important;
                            color: white !important;
                            box-shadow: none !important;
                        }

                        &:active {
                            background-color: rgba(255, 255, 255, 0.3) !important;
                            color: white !important;
                            box-shadow: none !important;
                        }
                        
                        svg {
                            color: white !important;
                            display: block !important;
                        }
                    }
                }

                .chat-title-reset {
                    cursor: pointer;
                }
            }

            .chat-content {
                overflow-y: auto;
                padding: 10px;
                z-index: 10;
                height: 100%;

                .chat-message-container {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: start;
                }

                .chat-robot-avatar {
                    margin-top: 5px;
                    width: 50px;
                    object-fit: contain;
                }

                .chat-message {
                    width: calc(100% - 55px);
                    min-height: 40px;
                    margin: 5px;
                    padding: 8px;
                    border: 1px solid;
                    border-radius: 10px;

                    .chat-message-time {
                        text-align: right;
                        font-size: 13px;
                    }

                    .chat-message-message {
                        font-size: 14px;
                    }
                }

                .chat-message.chat-message-system {
                    margin-right: 50px;
                    background-color: var(--greenia-color);
                    color: white;
                }

                .chat-message.chat-message-user {
                    margin-left: 50px;
                    border-color: var(--greenia-color);
                    background-color: white;
                }

                .chat-message.chat-message-option {
                    width: calc(100% - 60px);
                    margin-left: 50px;
                    background-color: rgba(80, 200, 120,.9);
                    border-color: var(--greenia-color);
                    cursor: pointer;
                    transition: .3s;

                    &:hover {
                        background-color: rgba(80, 200, 120,.8);
                    }
                }

                .chat-message.message-loading {
                    background-color: lightgrey;
                    border-color: grey;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    
                    .loading-spinner {
                        text-align: right;
                        font-size: 10px;
                    }
                }

                .chat-options-container {
                    max-height: 350px;
                    overflow-y: auto;
                }

                .chat-options-helper {
                    text-align: center;
                    color: var(--greenia-color);
                }
            }

            .chat-message-sender {
                padding: 10px;
                display: flex;
                align-items: center;
                border-top: 1px solid white;
                background-color: var(--greenia-color);
                z-index: 10001 !important;
                position: relative;

                textarea {
                    width: 100% !important;
                    min-height: 40px !important;
                    height: 40px !important;
                    max-height: 100px !important;
                    border: 1px solid white !important;
                    border-radius: 5px !important;
                    outline: none !important;
                    padding: 7px !important;
                    background-color: rgba(255,255,255,.9) !important;
                    font-size: 14px !important;
                    font-family: inherit !important;
                    resize: vertical !important;
                    
                    /* Force textarea interaction */
                    pointer-events: auto !important;
                    user-select: text !important;
                    cursor: text !important;
                    touch-action: manipulation !important;
                    -webkit-user-select: text !important;
                    -moz-user-select: text !important;
                    -ms-user-select: text !important;
                    position: relative !important;
                    z-index: 10002 !important;
                    
                    &:focus {
                        background-color: white !important;
                        border-color: white !important;
                        outline: 2px solid rgba(255,255,255,0.8) !important;
                        outline-offset: 1px !important;
                        box-shadow: 0 0 0 3px rgba(255,255,255,0.3) !important;
                    }
                    
                    &:hover {
                        background-color: rgba(255,255,255,.95) !important;
                    }
                    
                    &:active {
                        background-color: white !important;
                    }
                }

                .chat-message-send-button {
                    margin-left: 10px !important;
                    width: 50px !important;
                    min-width: 50px !important;
                    height: 40px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    background-color: var(--greenia-color) !important;
                    border: 1px solid white !important;
                    color: white !important;
                    border-radius: 5px !important;
                    cursor: pointer !important;
                    flex-shrink: 0 !important;
                    z-index: 10001 !important;
                    position: relative !important;
                }
            }
        }
    }

    .bottom-ref {
        height: 1px;
        width: 100%;
    }

    @keyframes cursor-blink {
        0% {
            opacity: 0;
        }
    }

    .blinking-cursor {
        width: 14px;
        height: 14px;
        border-radius: 100%;
        background-color: white;
        animation: cursor-blink 1s steps(2) infinite;
    }

    @media (max-width: 768px) {
        .chat-modal {
            .chat-container {
                width: 95%;
                height: 85%;
                max-width: none;
                
                .chat-title {
                    padding: 8px;
                    min-height: 45px;
                    
                    .chat-title-info {
                        font-size: 13px;
                        margin-right: 8px;
                    }
                    
                    .chat-title-actions {
                        gap: 6px;
                        
                        button {
                            min-width: 28px;
                            min-height: 28px;
                            font-size: 0.9rem;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 480px) {
        .chat-modal {
            .chat-container {
                .chat-title {
                    .chat-title-info {
                        font-size: 12px;
                        margin-right: 6px;
                    }
                    
                    .chat-title-actions {
                        button {
                            min-width: 26px;
                            min-height: 26px;
                            font-size: 0.8rem;
                        }
                    }
                }
            }
        }
    }
    
`;
